import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { ModalProps } from "antd/es/modal";
import { Button, InputNumber, message, Modal } from "antd";
import { ColumnProps } from "antd/es/table";
import CommonTable from "components/CommonTable";
import MultiLineColumn from "components/MultiLineColumn";
import { correctGroupMember, MemberGradeListItem } from "service/group";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import SubmitError from "components/SubmitError";

interface MembersScoreModalProps extends ModalProps {
    totalScore: number; //总分
    list: MemberGradeListItem[]; //成员得分列表
    onOk: () => void; //保存
    onCancel: () => void; //关闭
    loading: boolean;
}

export default function MembersScoreModal({
    totalScore,
    list,
    onOk,
    onCancel,
    loading: scoreLoading,
    ...props
}: MembersScoreModalProps) {
    const [onSave, { loading }] = useRequestFn(correctGroupMember);
    const [result, setResult] = useState<
        { id: number; memberScore: number; memberId: string }[]
    >([]);

    useEffect(() => {
        const newData = list.map(item => ({
            id: item.memberGradeId,
            memberScore:
                item.memberScore !== null ? item.memberScore : item.groupScore,
            memberId: item.memberId
        }));

        setResult(newData);
    }, [list]);

    const onChange = (e: number, id: number) => {
        const data = result.map(item => {
            if (item.id === id) {
                return {
                    id: id,
                    memberScore: e,
                    memberId: item.memberId
                };
            } else {
                return item;
            }
        });
        setResult(data);
    };

    //保存
    const onSaveScores = async () => {
        try {
            await onSave(result);
            onOk();
            message.success("保存成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="保存失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    const columns: ColumnProps<MemberGradeListItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (_, item: MemberGradeListItem, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: "学生信息",
            dataIndex: "memberNo",
            render: (val: string, item: MemberGradeListItem) => (
                <MultiLineColumn name={item.memberName} no={val} />
            )
        },
        {
            title: "小组得分",
            align: "center",
            dataIndex: "groupScore",
            render: (text: number) => <div>{text ? text : "--"}</div>
        },
        {
            title: "个人得分",
            align: "center",
            dataIndex: "memberScore",
            render: (_, item: MemberGradeListItem) => {
                const value =
                    result.find(v => v.memberId === item.memberId)
                        ?.memberScore || item.groupScore;
                return (
                    <InputNumber
                        max={totalScore}
                        min={0}
                        value={value}
                        onChange={e => onChange(e || 0, item.memberGradeId)}
                        placeholder="请输入"
                        disabled={!item.groupScore}
                    />
                );
            }
        }
    ];

    const footer = (
        <div>
            <Button onClick={onCancel}>取消</Button>
            <Button type="primary" onClick={onSaveScores} loading={loading}>
                保存
            </Button>
        </div>
    );

    return (
        <Modal
            title="小组成员评分"
            onCancel={onCancel}
            maskClosable={false}
            confirmLoading={false}
            className={style.root}
            footer={footer}
            width={610}
            {...props}>
            <CommonTable
                loading={scoreLoading}
                rowKey="memberId"
                columns={columns}
                dataSource={list}
                pagination={false}
                scroll={{ y: 324 }}
            />
        </Modal>
    );
}
